import React, { useState, useEffect } from "react";


import {connect} from 'react-redux';
import * as actions from '../../store/common/actions';

const YoutubePodcast = ({getPodcast, podcasts}) => {
    useEffect(() => { 
        getPodcast();
    },[])
    // console.log('podcasts', podcasts)
	if(podcasts && podcasts.length> 0){
		return (
			<div className="recently-played-sidebar">
                <div className="top">
                    <h2>PODCASTS</h2>
                    <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.02849 0.605551C5.95939 0.564275 5.8804 0.54248 5.79991 0.54248C5.71943 0.54248 5.64044 0.564275 5.57134 0.605551C5.51435 0.65071 5.47589 0.715201 5.46325 0.786812C5.45061 0.858423 5.46468 0.932183 5.50277 0.994122C6.90849 3.42841 7.20563 6.74269 5.28563 8.57127C4.54692 7.95049 3.96045 7.16853 3.57134 6.28555C2.86132 6.67989 2.27289 7.26121 1.86993 7.96638C1.46698 8.67155 1.2649 9.47363 1.28563 10.2856C1.31461 11.0013 1.48647 11.704 1.79108 12.3524C2.0957 13.0007 2.52691 13.5816 3.05936 14.0608C3.59181 14.54 4.21473 14.9078 4.89146 15.1427C5.5682 15.3776 6.28508 15.4747 6.99991 15.4284C10.6799 15.4284 12.5885 13.1427 12.7142 10.2856C12.8628 6.85698 10.4285 2.63984 6.02849 0.605551Z" stroke="#ff07b3" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M9.857 10.2856C9.857 10.8919 9.61619 11.4732 9.18753 11.9019C8.75888 12.3305 8.1775 12.5714 7.57129 12.5714" stroke="#ff07b3" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <div className="track-list recently-played">
                    <ul>
				{
					podcasts.map((podcast, podcastIndex) => {
						return <li key={`youtubepodcast-${podcastIndex}`}>
                                    <div className="podcast-contnainer">
                                        <div className="podcast-image-contnainer">
                                            <a href={podcast.url} target="_blank">
                                                <img src={podcast.image} alt={podcast.title} title={podcast.title} className="podcast-image" />
                                            </a>
                                        </div>
                                        <div className="track-name">
                                            <a href={podcast.url} target="_blank">
                                                <span className="text-2" dangerouslySetInnerHTML={{__html: podcast.title}}></span>
                                            </a>
                                        </div>
                                    </div>
                                </li>
									
					})
                }
                    </ul>
			    </div>
                <a className="primary-btn view-all-genres-btn" style={{minWidth: '80%'}} href="https://www.youtube.com/playlist?list=PLBoTD5a5LqNOLnxon9jQNISdUQrFekgGN" target="_blank">View All</a>
            </div>
		)
	} else {
		return '';
	}
}



function mapStateToProps(state) {
    return {
		podcasts: state.common.podcast,
    };
}
    
function mapDispatchToProps(dispatch) {
    return {
        getPodcast: () => dispatch(actions.getPodcast()),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(YoutubePodcast);